import { InlineGrid, Page } from '@shopify/polaris'
import React from 'react'
import VideoCardDynamic from '../../components/VideoCardDynamic'
import Video from '../../components/Video'

const Tutorials = () => {
    const videos = [
        {
            title: "Shopify shipping app not showing shipping rates on checkout",
            description: "In this course, you’ll learn about how to add the shipping rate.",
            url: "https://www.youtube.com/watch?v=nR34raPgyt8&list=PLkeebmoFziPwdGytDjJs51GuB3_OUzj5Q&index=2",
            thumbnail: "https://i.ytimg.com/vi/nR34raPgyt8/hqdefault.jpg"
        },
        // {
        //     title: "Unlock free trial - Advanced shipping rates Shopify app",
        //     description: "In this course, you’ll learn about how to add the shipping rate.",
        //     url: "https://www.youtube.com/watch?v=4bhUbDo9mdQ&list=PLkeebmoFziPwdGytDjJs51GuB3_OUzj5Q&index=1",
        //     thumbnail: "https://i.ytimg.com/vi/4bhUbDo9mdQ/hqdefault.jpg"
        // }
    ]
    return (
        <Page
            title='Tutorials'
        >
            <InlineGrid columns={4} gap={600}>
                {
                    videos.map(video =>
                        <Video
                            title={video.title}
                            description={video.description}
                            thumbnail={video.thumbnail}
                            url={video.url}
                            showCard={true}
                        />
                    )
                }
                {/* <VideoCardDynamic
                    title={"How to add Shipping Rate"}
                    description={"In this course, you’ll learn about how to add the shipping rate."}
                    thumbnail={"https://burst.shopifycdn.com/photos/business-woman-smiling-in-office.jpg?width=1850"}
                    url={"https://www.youtube.com/watch?v=JmR2i_qtWWw"}
                />
                <VideoCardDynamic
                    title={"How to add Shipping Rate"}
                    description={"In this course, you’ll learn about how to add the shipping rate."}
                    thumbnail={"https://burst.shopifycdn.com/photos/business-woman-smiling-in-office.jpg?width=1850"}
                    url={"https://www.youtube.com/watch?v=JmR2i_qtWWw"}
                />
                <VideoCardDynamic
                    title={"How to add Shipping Rate"}
                    description={"In this course, you’ll learn about how to add the shipping rate."}
                    thumbnail={"https://burst.shopifycdn.com/photos/business-woman-smiling-in-office.jpg?width=1850"}
                    url={"https://www.youtube.com/watch?v=JmR2i_qtWWw"}
                />
                <VideoCardDynamic
                    title={"How to add Shipping Rate"}
                    description={"In this course, you’ll learn about how to add the shipping rate."}
                    thumbnail={"https://burst.shopifycdn.com/photos/business-woman-smiling-in-office.jpg?width=1850"}
                    url={"https://www.youtube.com/watch?v=JmR2i_qtWWw"}
                /> */}
            </InlineGrid>
        </Page>
    )
}

export default Tutorials